export default [
  {
    id: 614536,
    createDate: "18.01.2021",
    amount: 9.0,
    amountInCurrency: 9.0,
    formOfPaymentName: "Karta kredytowa",
    paymentDate: "18.01.2021",
    description: null,
    documentNumber: "1/01/2021/KOR/RZE",
    linkDocumentNumbers: ["1118/11/2020/WM/RZE", "1114/11/2020/WM/RZE"],
    currency: "PLN",
    recordStampId: 7827091,
  },
];
